<template>
  <div class="store-mapping-form">
    <NavHeaderBar :showSearch="false" :navBarTitle="pageTitle" />
    <div class="create-store-form" v-if="!successStatus">
      <div class="form-item uploader-customer" v-if="customerId">
        <div class="label required">
          <span>{{ $t('form.checkInPhoto') }}</span>
        </div>
        <van-uploader v-model="customer.checkInImgUrl" max-count="1" :after-read="(files, detail) => afterRead(files, detail, 'checkInImgUrl')" />
      </div>
      <van-collapse v-model="activeNames">
        <van-collapse-item title="Basic info." name="1">
          <div class="form-item">
            <div class="label required">
              <span>{{ $t('form.storeName') }}</span>
            </div>
            <van-field v-model="customer.customerName" placeholder="" :border="false" class="custom-field" />
          </div>
          <div class="form-item">
            <div class="label required">
              <span>{{ $t('form.address') }}</span>
            </div>
            <van-field readonly v-model="customer.address" placeholder="" :border="false" class="custom-field" @click="getAddress" />
          </div>
          <div class="form-item">
            <div class="label required">
              <span>{{ $t('form.outsidePicture') }}</span>
            </div>
            <van-uploader v-model="customer.imgUrl" max-count="1" :after-read="(files, detail) => afterRead(files, detail, 'imgUrl')" />
          </div>
          <div class="form-item">
            <div class="label required">
              <span>{{ $t('form.storeType') }}</span>
            </div>
            <XuSelect v-model="customer.customerType" :dataOptions="customerTypeList" />
          </div>
          <div class="form-item">
            <div class="label required">
              <span>{{ $t('form.businessStatus') }}</span>
            </div>
            <XuSelect v-model="customer.status" :dataOptions="statusList" />
          </div>
          <div class="form-item">
            <div class="label required">
              <span>{{ $t('form.chainOrNot') }}</span>
            </div>
            <van-field class="custom-field custom-radio-field">
              <template #input>
                <van-radio-group v-model="customer.isChain" direction="horizontal">
                  <van-radio v-for="(subItem, subIndex) in radioList" :key="subIndex" :name="subItem.value">{{ subItem.label }}</van-radio>
                </van-radio-group>
              </template>
            </van-field>
          </div>
          <div class="form-item" v-if="customer.isChain === true">
            <div class="label required">
              <span>{{ $t('form.numberofChainStores') }}</span>
            </div>
            <van-field v-model.number="customer.chainCount" type="digit" placeholder="" :border="false" class="custom-field" />
          </div>
          <div class="subset-form-item" v-if="customer.isChain === true">
            <div class="label required">
              <span>{{ $t('shared.distributor') }}</span>
            </div>
            <div class="select-field custom-field" @click="toSelectStoreSd('reorderList')">
              {{ customer.belongSd.sdName }}
            </div>
          </div>
        </van-collapse-item>
        <van-collapse-item :title="$t('form.decisionMakerInfo')" name="2">
          <div class="form-item">
            <div class="label">
              <span>{{ $t('form.decisionMakerName') }}</span>
            </div>
            <van-field v-model="decisionContact.contactName" placeholder="" :border="false" class="custom-field" />
          </div>
          <div class="form-item">
            <div class="label">
              <span>{{ $t('form.decisionMakerRole') }}</span>
            </div>
            <XuSelect v-model="decisionContact.job" :dataOptions="jobList" />
          </div>
          <div class="form-item">
            <div class="label">
              <span>{{ $t('form.phone') }}</span>
            </div>
            <van-field v-model="decisionContact.phone" type="number" placeholder="" :border="false" class="custom-field" />
          </div>
          <div class="form-item">
            <div class="label">
              <span>{{ $t('form.email') }}</span>
            </div>
            <van-field v-model="decisionContact.email" placeholder="" :border="false" class="custom-field" />
          </div>
          <div class="form-item">
            <div class="label">
              <span>{{ $t('form.notes') }}</span>
            </div>
            <van-field v-model="decisionContact.remark" placeholder="" :border="false" class="custom-field" />
          </div>
        </van-collapse-item>
        <van-collapse-item :title="$t('form.footTrafficInformation')" name="3">
          <div class="form-item">
            <div class="label">
              <span>{{ $t('form.weekdayFootTraffic') }}</span>
            </div>
            <van-field v-model="customer.weekdayTraffic" placeholder="" type="number" :border="false" class="custom-field" />
          </div>
          <div class="form-item">
            <div class="label">
              <span>{{ $t('form.weekdayPeakTraffic') }} {{ $t('form.timePeriods') }}</span>
            </div>
            <XuTime v-model="customer.weekdayPeakTrafficTime" />
          </div>
          <div class="form-item">
            <div class="label">
              <span>{{ $t('form.weekendFootTraffic') }}</span>
            </div>
            <van-field v-model="customer.weekendTraffic" placeholder="" type="number" :border="false" class="custom-field" />
          </div>
          <div class="form-item">
            <div class="label">
              <span>{{ $t('form.weekendPeakTraffic') }} {{ $t('form.timePeriods') }}</span>
            </div>
            <XuTime v-model="customer.weekendPeakTrafficTime" />
          </div>
        </van-collapse-item>
        <van-collapse-item :title="`${$t('shared.store')} ${$t('form.customerReach')}`" name="4">
          <div class="form-item">
            <div class="label custom-label">
              <span>{{ $t('form.disposableBrandDiversity') }}</span>
            </div>
            <!-- <van-field v-model="customer.disposableBrandDiversity" placeholder="" :border="false" class="custom-field" /> -->
            <XuSelect v-model="customer.disposableBrandDiversity" :dataOptions="brandDiersityList" />
          </div>
        </van-collapse-item>
        <van-collapse-item :title="`${$t('shared.store')} ${$t('form.promotionCapability')}`" name="5">
          <div class="form-item">
            <div class="label">
              <span>{{ $t('form.officialWebsiteAvailable') }}</span>
            </div>
            <van-field class="custom-field custom-radio-field">
              <template #input>
                <van-radio-group v-model="customer.isOnlineWeb" direction="horizontal">
                  <van-radio v-for="(subItem, subIndex) in radioList" :key="subIndex" :name="subItem.value">{{ subItem.label }}</van-radio>
                </van-radio-group>
              </template>
            </van-field>
          </div>
          <div class="form-item">
            <div class="label">
              <span>{{ $t('form.whatsAppGroupAvailable') }}</span>
            </div>
            <van-field class="custom-field custom-radio-field">
              <template #input>
                <van-radio-group v-model="customer.isWhatsappGroup" direction="horizontal">
                  <van-radio v-for="(subItem, subIndex) in radioList" :key="subIndex" :name="subItem.value">{{ subItem.label }}</van-radio>
                </van-radio-group>
              </template>
            </van-field>
          </div>
          <div class="form-item">
            <div class="label">
              <span>{{ $t('form.facebookInstagramAvailable') }}</span>
            </div>
            <van-field class="custom-field custom-radio-field">
              <template #input>
                <van-radio-group v-model="customer.isIns" direction="horizontal">
                  <van-radio v-for="(subItem, subIndex) in radioList" :key="subIndex" :name="subItem.value">{{ subItem.label }}</van-radio>
                </van-radio-group>
              </template>
            </van-field>
          </div>
        </van-collapse-item>
        <van-collapse-item v-if="checkPer(['admin', 'app:expandCustomer:brandPrice'])" :title="`${globalData.brandName} ${$t('form.retailPrice')}`" name="6">
          <div class="form-item" v-for="(brandItem, brandIndex) in retailPriceList" :key="brandIndex">
            <div class="label square">
              <span>{{ brandItem.projectName }}</span>
            </div>
            <div class="brand-item" v-for="(subItem, subIndex) in brandItem.productList" :key="subIndex">
              <div class="product-status">
                <XuSelect v-model="subItem.productId" :dataOptions="filteredOptions(brandItem, subItem.productId)" :fieldNames="{label: 'productName', value: 'id'}" />
                <img src="@/assets/images/event_del.png" alt="" class="del-img" @click="handleDel(brandItem, subIndex)">
              </div>
              <div class="product-listing">
                <div class="listing-item">
                  <div class="listing-label">{{ $t('form.retailPrice') }}({{ $t('form.uSD') }})</div>
                  <van-field v-model="subItem.retailPrice" type="number" placeholder="" :border="false" class="custom-field" />
                </div>
              </div>
            </div>
            <div class="add-more" @click="handleAdd('retailPriceList', brandItem)">+ {{ $t('button.addMoreProduct') }}</div>
          </div>
        </van-collapse-item>
      </van-collapse>
    </div>
    <div class="success-submit-status" v-else>
      <img class="success-img" src="@/assets/images/gouxuan.png" alt="">
      <!-- 当前门店mapping成功，接下来可通过visit收集更多门店信息 -->
      <span class="success-tip">{{ $t('tips.messageForty') }}</span>
      <div class="store-detail-btn" @click="toPage(`/storeExpansion/storeMappingDetail`)">{{ $t('button.storeDetial') }}</div>
      <div class="visit-sell-in-btn" v-if="checkPer(['admin', 'app:expand:addOrUpdate']) && !['storeMaintain'].includes(pageType) && ![-1, -2, -3, '-1', '-2', '-3'].includes(customer.status)" @click="toPage(`/storeExpansion/visitSellIn?customerId=${customerId}`, 'visit')">{{ $t('shared.visitSellIn') }}</div>
    </div>
    <div class="oper-btn" v-if="!successStatus">
      <van-button class="mapping-btn" type="info" @click="handleSubmit">{{ $t('button.submit') }}</van-button>
    </div>
    <XuVisitDialog ref="xuVisitDialogRef" :currentVisitInfo="currentVisitInfo" :customerId="customerId" pageType="storeExpansion" />
  </div>
</template>

<script>
import { Toast, Dialog } from 'vant'
import { arsAddCustomerApi, arsUpdateCustomerApi, arsCustomerUpdateInfoApi } from '@/api/home'
import XuTime from '@/components/XuTime.vue'
import { arsVisitLastApi } from '@/api/visit'
import { mapState } from 'vuex'
export default {
  name: 'StoreMapping',
  components: {
    XuSelect: () => import('@/components/XuSelect'),
    XuTime,
    XuVisitDialog: () => import('@/components/XuVisitDialog')
  },
  data () {
    return {
      successStatus: false,
      customerId: '',
      pageType: 'storeExpansion',
      activeNames: ['1'],
      customer: {
        lng: '',
        lat: '',
        customerName: '',
        address: '',
        customerType: '',
        status: '',
        isChain: '',
        imgUrl: [],
        checkInImgUrl: [],
        weekdayTraffic: '',
        weekdayPeakTrafficTime: [{ start: '', end: '' }],
        weekendTraffic: '',
        weekendPeakTrafficTime: [{ start: '', end: '' }],
        chainCount: '',
        disposableBrandDiversity: '',
        isOnlineWeb: '',
        isWhatsappGroup: '',
        isIns: '',
        belongSd: {
          id: '',
          sdName: ''
        }
      },
      decisionContact: {
        contactName: '',
        job: '',
        phone: '',
        email: '',
        remark: ''
      },
      retailPriceList: [],
      jobList: [],
      customerTypeList: [],
      // shelfList: [],
      listingStatusList: [],
      radioList: [
        { label: this.$t('shared.filter.yes'), value: true },
        { label: this.$t('shared.filter.no'), value: false }
      ],
      brandDiersityList: [
        { label: this.$t('shared.filter.rich'), value: 'Rich' },
        { label: this.$t('shared.filter.good'), value: 'Good' },
        { label: this.$t('shared.filter.poor'), value: 'Poor' }
      ],
      currentVisitInfo: {},
      pageTitle: this.$t('shared.title.storeMapping'),
      statusList: [
        { label: this.$t('form.business'), value: 1 }, // 正常营业
        { label: this.$t('form.temporarilyClosed'), value: -1 }, // 暂时性歇业
        { label: this.$t('form.permanentlyClosed'), value: -2 }, // 永久性歇业
        { label: this.$t('form.invalid'), value: -3 } // 无效数据
      ]
    }
  },
  computed: {
    ...mapState({
      globalData: 'globalData',
      userInfo: 'myUserInfo'
    }),
    filteredOptions () {
      return (brandItem, currentId) => {
        if (!this.globalData.productList || !brandItem.productList) return []
        const projectId = brandItem.projectId
        const selectedIds = brandItem.productList.map(item => item.productId).filter(id => id && id !== currentId)
        return this.globalData.productList.filter(item => !selectedIds.includes(item.id) && item.projectId === projectId)
      }
    }
  },
  // mounted () {
  //   this.customerId = this.$route.query.customerId || ''
  //   console.log('mounted', this.customerId)
  //   this.initData()
  // },
  activated () {
    if (this.isNavigateToSdSelect) {
      const sdStoreSelect = JSON.parse(window.localStorage.getItem('sdStoreSelect'))
      if (sdStoreSelect) {
        this.customer.belongSd.id = sdStoreSelect.typeValue[0] ? sdStoreSelect.typeValue[0].id : ''
        this.customer.belongSd.sdName = sdStoreSelect.typeValue[0] ? sdStoreSelect.typeValue[0].sdName : ''
        window.localStorage.removeItem('sdStoreSelect')
      }
    } else {
      this.pageType = this.$route.query.pageType || 'storeExpansion'
      this.pageTitle = this.$t('shared.title.storeMapping')
      this.activeNames = ['1']
      this.successStatus = false
      this.customerId = this.$route.query.customerId || ''
      this.$nextTick(() => {
        this.initData()
      })
    }
    this.isNavigateToSdSelect = false
  },
  beforeRouteLeave (to, from, next) {
    if (to.path === '/shared/selectStoreSd') {
      this.isNavigateToSdSelect = true
    }
    next()
  },
  methods: {
    handleAdd (type, params = {}) {
      if (params.productList.length >= this.globalData.productList.filter(item => item.projectId === params.projectId).length) {
        Toast(this.$t('tips.noMoreProducts'))
        return
      }
      if (type === 'retailPriceList') {
        params.productList.push({
          productId: '',
          retailPrice: ''
        })
      }
    },
    handleDel (params, index) {
      Dialog.confirm({
        message: this.$t('tips.messageNine'),
        confirmButtonText: this.$t('button.comfirm'),
        cancelButtonText: this.$t('button.cancel'),
        confirmButtonColor: '#c4200b'
      })
        .then(() => {
          params.productList.splice(index, 1)
        })
        .catch(() => {
          // on cancel
        })
    },
    handleSubmit () {
      if (!this.checkedForm()) return
      const { status } = this.customer
      if ([-1, -2, -3, '-1', '-2', '-3'].includes(status)) {
        const statusVal = [-1, '-1'].includes(status) ? this.$t('form.temporarilyClosed') : [-2, '-2'].includes(status) ? this.$t('form.permanentlyClosed') : [-3, '-3'].includes(status) ? this.$t('form.invalid') : ''
        Dialog.confirm({
          // message: `将门店营业状态改为：${statusVal}，该门店将无法被mapping与拜访，确认修改吗？`,
          message: this.$t('tips.messageFortyOne', { statusVal: statusVal }),
          confirmButtonText: this.$t('button.confirm'),
          cancelButtonText: this.$t('button.cancel'),
          confirmButtonColor: '#c4200b'
        })
          .then(() => {
            this.dataSubmit()
          })
          .catch((err) => {
            console.log('err', err)
          })
      } else {
        this.dataSubmit()
      }
    },
    dataSubmit () {
      const { imgUrl, weekdayPeakTrafficTime, weekendPeakTrafficTime, checkInImgUrl } = this.customer
      // this.shelfList.forEach(subItem => {
      //   subItem.shelfType = subItem.shelfType.join(',')
      // })
      const data = {
        customer: {
          ...this.customer,
          imgUrl: imgUrl.map(imgItem => imgItem.url).join(','),
          checkInImgUrl: checkInImgUrl.map(imgItem => imgItem.url).join(','),
          weekdayPeakTrafficTime: weekdayPeakTrafficTime.length <= 0 ? '' : weekdayPeakTrafficTime.map(timeItem => `${timeItem.start}~${timeItem.end}`).join(','),
          weekendPeakTrafficTime: weekendPeakTrafficTime.length <= 0 ? '' : weekendPeakTrafficTime.map(timeItem => `${timeItem.start}~${timeItem.end}`).join(','),
          id: this.customerId
        },
        decisionContact: this.decisionContact,
        retailPriceList: this.retailPriceList
        // shelfList: this.shelfList
      }
      const requestApi = this.customerId ? arsUpdateCustomerApi : arsAddCustomerApi
      Toast.loading({
        message: this.$t('shared.loading'),
        forbidClick: true,
        duration: 0
      })
      requestApi(data).then(res => {
        Toast.clear()
        this.customerId = res.data.id
        this.successStatus = true
        this.pageTitle = this.$t('shared.title.mappingSucceed')
        localStorage.removeItem('centerPoint')
      })
    },
    toPage (url, type) {
      if (type === 'visit') {
        if (!this.customerId) {
          return
        }
        Toast.loading({
          message: this.$t('shared.loading'),
          forbidClick: true,
          duration: 0
        })
        arsVisitLastApi(this.customerId, '1').then(res => {
          Toast.clear()
          this.currentVisitInfo = res.data
          if (res.data.lastType === 0) {
            this.$router.replace(url)
          } else {
            this.$refs.xuVisitDialogRef.dialogShow = true
          }
        })
      } else if (url === '/storeExpansion/storeMappingDetail') {
        if (this.pageType === 'storeExpansion') {
          this.$router.replace(`${url}?customerId=${this.customerId}&pageType=${this.pageType}`)
        } else {
          this.$router.replace(`/storeMaintain/storeMappingDetail?customerId=${this.customerId}&pageType=${this.pageType}`)
        }
      } else {
        this.$router.replace(url)
      }
    },
    getUpdateInfo () {
      if (JSON.parse(localStorage.getItem('centerPoint'))) return
      Toast.loading({
        message: this.$t('shared.loading'),
        forbidClick: true,
        duration: 0
      })
      arsCustomerUpdateInfoApi(this.customerId).then(res => {
        Toast.clear()
        const { customer, decisionContact, retailPriceList, shelfList } = res.data
        retailPriceList.forEach(brandItem => {
          brandItem.productList = brandItem.productList.filter(subItem => {
            return subItem.retailPrice
          })
        })
        this.retailPriceList = retailPriceList
        // shelfList.forEach(subItem => {
        //   subItem.shelfType = subItem.shelfType.length > 0 ? subItem.shelfType.split(',') : []
        // })
        // this.shelfList = shelfList
        Object.keys(this.decisionContact).forEach(subItem => {
          this.decisionContact[subItem] = decisionContact[subItem] || ''
        })
        Object.keys(this.customer).forEach(subItem => {
          if (subItem === 'imgUrl') {
            this.customer[subItem] = customer[subItem] ? customer[subItem].split(',').map(imgItem => {
              return { url: imgItem }
            }) : []
          } else if (subItem === 'checkInImgUrl') {
            this.customer[subItem] = []
          } else if (['weekdayPeakTrafficTime', 'weekendPeakTrafficTime'].includes(subItem)) {
            // '9:30~3:30,9:30~3:30' [9:30~3:30, 9:30~3:30]
            if (customer[subItem]) {
              const newTime = []
              const startEndTimeList = customer[subItem].split(',')
              startEndTimeList.forEach(timeItem => {
                newTime.push({ start: timeItem.split('~')[0], end: timeItem.split('~')[1] })
              })
              this.customer[subItem] = newTime
            } else {
              this.customer[subItem] = [{ start: '', end: '' }]
            }
          } else if (['belongSd'].includes(subItem)) {
            this.$set(this.customer, subItem, customer[subItem] || { id: '', sdName: '' })
          } else {
            // this.customer[subItem] = customer[subItem] || ''
            this.$set(this.customer, subItem, customer[subItem] || '')
          }
        })
      })
    },
    afterRead (files, detail, key) {
      Toast.loading({
        message: this.$t('shared.loading'),
        forbidClick: true,
        duration: 0
      })
      this.$uploadImg(files)
        .then((res) => {
          Toast.clear()
          this.$set(this.customer[key], detail.index, {
            url: res.url
          })
        })
        .catch((err) => {
          console.log('err', err)
          Toast.clear()
          Toast(this.$t('tips.uploadFailed'))
        })
    },
    handleTips () {
      Dialog.alert({
        message: this.$t('tips.messageEight'),
        confirmButtonText: this.$t('button.gotIt'),
        confirmButtonColor: '#307bff'
      }).then(() => {
        // on close
      })
    },
    getAddress () {
      const query = {
        longitude: this.customer.lng || '',
        latitude: this.customer.lat || ''
      }
      this.$router.push({
        path: '/chooseLocation',
        query: query
      })
    },
    // 校验必填
    checkedForm () {
      const field = [
        { tipsText: this.$t('form.storeName'), value: 'customerName' },
        { tipsText: this.$t('form.address'), value: 'address' },
        { tipsText: this.$t('form.outsidePicture'), value: 'imgUrl' },
        { tipsText: this.$t('form.storeType'), value: 'customerType' },
        { tipsText: this.$t('form.businessStatus'), value: 'status' },
        { tipsText: this.$t('form.chainOrNot'), value: 'isChain' }
      ]
      if (this.customer.isChain === true) {
        field.push({ tipsText: this.$t('form.numberofChainStores'), value: 'chainCount' })
        field.push({ tipsText: this.$t('shared.distributor'), value: 'id' })
      }
      let isFlag = true
      if (this.customerId && this.customer.checkInImgUrl.length <= 0) {
        Toast(`${this.$t('form.checkInPhoto')} ${this.$t('tips.isRequired')}`)
        isFlag = false
        return isFlag
      }
      field.find(subItem => {
        if (this.isEmptyVal(this.getFieldVal(subItem.value))) {
          isFlag = false
          Toast(`${subItem.tipsText} ${this.$t('tips.isRequired')}`)
          return true // find 只需返回 true 终止遍历，比 return subItem 语义清晰
        }
      })
      return isFlag
    },
    // 空字符串 / 空数组 视为空
    isEmptyVal (val) {
      return val === '' || (Array.isArray(val) && val.length === 0)
    },
    getFieldVal (key) {
      if (key === 'id') return this.customer.belongSd.id
      return this.customer[key]
    },
    initData () {
      const centerPoint = JSON.parse(localStorage.getItem('centerPoint'))
      if (centerPoint) {
        this.customer.address = centerPoint.address
        this.customer.lng = centerPoint.lng
        this.customer.lat = centerPoint.lat
      }
      this.jobList = []
      this.listingStatusList = []
      this.customerTypeList = []
      this.globalData.customerJob.forEach(subItem => {
        this.jobList.push({ label: subItem.label, value: JSON.parse(subItem.value).val })
      })
      this.globalData.customerTypeList.forEach(subItem => {
        this.customerTypeList.push({ label: subItem.label, value: subItem.value })
      })
      this.globalData.shelfType.forEach(subItem => {
        this.listingStatusList.push({ label: subItem.label, value: subItem.value })
      })
      this.getUpdateInfo()
    },
    toSelectStoreSd (currKey, params) {
      const { id, sdName } = this.customer.belongSd
      window.localStorage.setItem('sdStoreSelect', JSON.stringify({ typeKey: currKey, typeValue: id ? [{ id: id, sdName: sdName }] : [] }))
      this.$router.push('/shared/selectStoreSd?sdType=KA&selectMode=single')
    }
  }
}
</script>

<style scoped lang="less">
.store-mapping-form {
  height: 100%;
  background-color: #f5f5f9;
  display: flex;
  flex-direction: column;
  overflow: auto;
  .success-submit-status {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 100px;
    .success-img {
      width: 80px;
      height: 80px;
    }
    .success-tip {
      width: 260px;
      text-align: center;
      margin: 16px 0 40px 0;
      font-size: 13px;
    }
    .store-detail-btn,
    .visit-sell-in-btn {
      width: 260px;
      padding: 16px 0px;
      border: 1px solid #555;
      color: #555;
      text-align: center;
      font-weight: bold;
      font-size: 17px;
      border-radius: 30px;
      margin-bottom: 16px;
    }
    .visit-sell-in-btn {
      border-color: #307bff;
      color: #307bff;
    }
  }
  .oper-btn {
    width: 100%;
    .mapping-btn {
      width: 100%;
      background-color: #307bff;
      font-weight: bold;
    }
  }
  .create-store-form {
    flex: 1;
    overflow-y: auto;
    padding: 5px 0;
    .uploader-customer {
      display: flex;
      justify-content: space-between;
      background-color: #fff;
      padding-top: 10px !important;
      margin-bottom: 0 !important;
      .label {
        align-self: flex-start;
      }
    }
    /deep/.van-collapse {
      .van-collapse-item {
        background-color: #fff;
        .van-collapse-item__title {
          background-color: #e8effc;
          font-weight: bold;
          padding: 5px 10px;
          margin-bottom: 2px;
          .van-cell__title {
            font-weight: bold;
            > span {
              font-size: 14px;
            }
          }
        }
        .van-collapse-item__content {
          padding: 0;
          padding-top: 10px;
        }
      }
    }
    .form-item,
    .subset-form-item {
      padding: 0 10px;
      margin-bottom: 13px;
      .label {
        display: flex;
        align-items: center;
        font-size: 12px;
        color: #333;
        margin-bottom: 8px;
        // 添加必填标记样式
        &.required {
          position: relative;
          padding-left: 12px; // 为星号预留空间
          &::before {
            content: '*';
            color: #ff4444;
            position: absolute;
            left: 0;
            top: 0;
            font-size: 14px;
            line-height: 1;
          }
        }
        &.square {
          font-weight: bold;
          &::before {
            content: '';
            width: 8px;
            height: 8px;
            background-color: #307bff;
            // position: absolute;
            // left: 0;
            // top: 0;
            transform: rotate(45deg);
            margin-right: 5px;
          }
        }
      }
      .custom-field {
        padding: 5px 10px;
        background: #fff;
        border: 1px solid #b9cbed;
        border-radius: 4px;
        font-size: 12px;
        &::placeholder {
          color: #999;
        }
      }
      .custom-radio-field {
        padding: 0;
        font-size: 12px;
        border: none;
      }
      .phone-inputs {
        display: flex;
        align-items: center;
        .custom-field {
          flex: 1;
          text-align: center;
        }
        span {
          margin: 0 5px;
        }
      }
      .brand-item {
        font-size: 12px;
        margin-bottom: 10px;
        .product-status {
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
        .product-listing {
          padding: 10px;
          margin-top: 10px;
          background-color: #f7f7f7;
          border-radius: 10px;
          .listing-item {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 5px;
            .listing-label {
              font-size: 12px;
              color: #333;
            }
            /deep/.van-cell {
              width: auto;
            }
          }
        }
      }
      .del-img {
        width: 20px;
        height: 20px;
        margin-left: 5px;
      }
      .add-more {
        display: inline-block;
        padding: 5px;
        font-size: 12px;
        color: #307bff;
        border: 1px solid #307bff;
        background-color: #e4eefc;
        border-radius: 6px;
        margin-bottom: 10px;
      }
      .select-field {
        display: flex;
        align-items: center;
        min-height: 36px;
        color: #333;
      }
    }
    .custom-label {
      display: flex;
      align-items: center;
    }
  }
}
</style>
